// index.tsx
import React from "react";
import { Button } from "Components/atoms/Button";
import { Typography } from "Components/atoms/Typography";
import { StyledSearchErrorContent } from "./styles";

type SearchErrorContentProps = {
  title: string;
  description: string;
  /** Texto do botão. O botão só aparece com `onAction`. */
  actionLabel?: string;
  onAction?: () => void;
};

/**
 * Componente SearchErrorContent
 *
 * Aviso no lugar dos resultados quando a busca não pode ser feita (por exemplo,
 * data que já passou) ou falhou, com uma ação opcional para tentar de novo.
 */
export const SearchErrorContent: React.FC<SearchErrorContentProps> = ({
  title,
  description,
  actionLabel,
  onAction,
}) => {
  return (
    <StyledSearchErrorContent role="alert">
      <Typography variant="h3" color="darkGray">
        {title}
      </Typography>
      <Typography variant="body" color="darkGray">
        {description}
      </Typography>
      {onAction && actionLabel && (
        <Button
          label={actionLabel}
          onClick={onAction}
          backgroundColor="darkBlue"
          size="medium"
        />
      )}
    </StyledSearchErrorContent>
  );
};

export default SearchErrorContent;
